import React from 'react';
import { Route, Switch } from "react-router-dom";
import { routesConfig } from './config'

const Routes = () => {
  return (
    <Switch>
      {routesConfig.map(route => 
        (<Route
          exact={route.exact}
          path={route.path}
          key={route.name}
          component={route.component}
        />)
      )}
    </Switch>
  )
}

export { routesConfig }
export default Routes